<!-- Page Header -->
<app-title-bar
  title="Customers"
  description="Track and manage customers by company"
  [showButton]="false"
>
</app-title-bar>

<!-- Stats Cards -->
<div class="stats-container">
  <div class="stats-grid">
    <app-customer-stats-card
      *ngFor="let stat of customerStats; trackBy: trackByIndex"
      [data]="stat"
    >
    </app-customer-stats-card>
  </div>
</div>

<!-- Search and Filter Section -->
<div class="search-filter-section">
  <app-searchbar
    placeholder="Search for customers by name, email, phone..."
    [(searchTerm)]="searchTerm"
    (searchChange)="onSearchChange($event)"
    iconSize="small"
  >
  </app-searchbar>

  <div class="filter-container">
    <!-- Company Dropdown -->
    <app-simple-dropdown
      [options]="companyOptions"
      [selectedValue]="selectedCompanyId"
      [title]="'Select Company'"
      [isOpen]="isCompanyDropdownOpen"
      (selectionChange)="selectCompany($event)"
      (toggle)="toggleCompanyDropdown()"
      (close)="closeCompanyDropdown()"
    >
    </app-simple-dropdown>

    <!-- <app-action-button
          buttonText="Filter"
          iconSrc="assets/images/package/adjustments.svg"
          [showCount]="hasActiveFilters"
          [count]="getActiveFilterCount()"
          (buttonClick)="onFilter()">
        </app-action-button> -->
  </div>
</div>

<!-- Customers Table (Only show when there are customers to display) -->
<div *ngIf="!loading && customers.length > 0" class="table-container">
  <div class="table-scroll-wrapper" #tableScrollWrapper>
    <table class="orders-table">
      <thead>
        <tr>
          <th (click)="sortByName()" style="cursor: pointer">
            Name
            <img [src]="getSortIcon('name')" alt="Sort" class="sort-icon" />
          </th>
          <th (click)="sortByEmail()" style="cursor: pointer">
            Email
            <img [src]="getSortIcon('email')" alt="Sort" class="sort-icon" />
          </th>
          <th>Phone Number</th>
          <th>Vehicles</th>
          <th>License Plate</th>
          <th>Status</th>

          <th>Number of Visits</th>
          <th>Revenue</th>
          <th>Last Visit</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let customer of customers; trackBy: trackById" class="order-row">
          <td class="customer-name">{{ customer.name || '-' }}</td>
          <td class="email">{{ customer.email || '-' }}</td>
          <td class="phone">{{ customer.contact || '-' }}</td>
          <td>{{ customer.vehicles || '-' }}</td>
          <td class="license-plate">{{ customer.license_plate || '-' }}</td>
          <td class="status-cell">
            <span class="status-badge" [ngClass]="getStatusClass(customer.customer_status)">
              {{
                customer.customer_status === 'active'
                  ? 'Active'
                  : customer.customer_status === 'inactive'
                    ? 'Inactive'
                    : '-'
              }}
            </span>
          </td>

          <td>{{ customer.numberOfVisits || '-' }}</td>
          <td>{{ customer.revenue || '-' }}</td>
          <td>{{ formatLastVisitDate(customer.lastVisit) || '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Loading State - Shimmer Effect -->
<div *ngIf="loading" class="loading-container">
  <app-loading-table-shimmer
    [columns]="shimmerColumns"
    [rows]="10"
    [showHeader]="false"
    className="scrollable"
  >
  </app-loading-table-shimmer>
</div>

<!-- Empty State - No Customers (when there are truly no customers) -->
<div
  *ngIf="!loading && customers.length === 0 && !hasSearchOrFilters && selectedCompanyId"
  class="empty-state-container"
>
  <app-empty-result
    image="/assets/images/empty_screen.png"
    title="No customers to show"
    description="No customers found for the selected company."
    [actionText]="''"
    [showAction]="false"
  >
  </app-empty-result>
</div>

<!-- Empty State - No Company Selected -->
<div *ngIf="!loading && !selectedCompanyId" class="empty-state-container">
  <app-empty-result
    image="/assets/images/empty_screen.png"
    title="Select a company"
    description="Please select a company to view customers."
    [actionText]="''"
    [showAction]="false"
  >
  </app-empty-result>
</div>

<!-- Empty State - No Search Results (when search/filters are active but no results) -->
<div
  *ngIf="!loading && customers.length === 0 && hasSearchOrFilters && selectedCompanyId"
  class="empty-state-container"
>
  <app-empty-result
    image="/assets/images/empty_screen.png"
    title="No results found!"
    description="Please try again or modify your search or filters."
    [actionText]="''"
    [showAction]="false"
  >
  </app-empty-result>
</div>

<!-- Pagination -->
<app-pagination-bar
  *ngIf="!loading && customers.length > 0"
  [paginationData]="paginationData"
  [itemsPerPageOptions]="[10, 25, 50]"
  (pageChange)="onPageChange($event)"
  (itemsPerPageChange)="onItemsPerPageChange($event)"
>
</app-pagination-bar>

<!-- Filter Modal -->
<app-filter-modal
  [isVisible]="showFilterModal"
  header="Filters"
  primaryButtonText="Apply Filters"
  secondaryButtonText="Clear Filters"
  [categories]="filterCategories"
  (close)="onCloseFilterModal()"
  (apply)="onFilterModalApply($event)"
>
</app-filter-modal>
